import { mapState } from "../store/map";
export default {
  name: "KilaKilaCategoryCard",
  setup: function setup() {
    var _mapState = mapState("categoryAbout"),
        categoryCounts = _mapState.categoryCounts;

    return {
      categoryCounts: categoryCounts
    };
  }
};